/* eslint-disable no-param-reassign */
import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { ClientData, IToken, User } from "types/auth";

export interface AuthState {
  loggedUser: User | null;
  clientData: ClientData | null;
  token: IToken | null;
  isLoadingClientData: boolean;
}

const initialState: AuthState = {
  loggedUser: null,
  clientData: null,
  isLoadingClientData: false,
  token: null,
};

const slice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setLoggedUser: (state, action: PayloadAction<User>) => {
      state.loggedUser = action.payload;
    },
    setClientData: (state, action: PayloadAction<ClientData>) => {
      state.clientData = action.payload;
    },
    setLoadingClientData: (state, action: PayloadAction<boolean>) => {
      state.isLoadingClientData = action.payload;
    },
    unsetAuthenticated: (state) => {
      state.loggedUser = null;
      state.token = null;
    },
    setToken: (state, action: PayloadAction<IToken>) => {
      state.token = action.payload;
    },
  },
});

export const {
  setLoggedUser,
  unsetAuthenticated,
  setToken,
  setClientData,
  setLoadingClientData,
} = slice.actions;

export const { reducer } = slice;
